import React, { ReactNode } from 'react';
import { LinkButton } from '@/components/ui/Buttons';
import cn from '@/utils/cn';

interface FilterPanelProps {
  children: ReactNode;
  className?: string;
  hideClear?: boolean;
  onClear: () => void;
  topClassName?: string;
}

// AIDEV-NOTE: Shared shell for library filter sidebars. Renders the sticky
// container, "Filters" header, "Clear" link and divider. Consumers pass their
// FilterCategory rows as children. Width matches the Search-page filter rail
// (15rem / tw-basis-60). `topClassName` lets consumers override the sticky
// offset (default tw-top-10 == 2.5rem; the Games and Video library rails use
// tw-top-4 == 1rem to sit closer to the top, since there's no fixed header to clear).
const FilterPanel = ({
  children,
  className,
  hideClear = false,
  onClear,
  topClassName = 'tw-top-10',
}: FilterPanelProps) => (
  <div className={cn('tw-sticky tw-h-0 tw-flex-grow-0 tw-flex-shrink-0 tw-basis-60', topClassName)}>
    <div className={cn('card tw-p-3 tw-bg-white', className)}>
      <div className="tw-flex tw-items-center tw-justify-between">
        <h2 className="tw-font-bold tw-m-0">Filters</h2>
        {!hideClear && (
          <LinkButton className="tw-text-sm tw-cursor-pointer tw-px-0" onClick={onClear}>
            Clear
          </LinkButton>
        )}
      </div>
      <hr className="tw-mx-1 tw-my-2" />
      {children}
    </div>
  </div>
);

export default FilterPanel;
